const createPluginSystemContext = ({ actions, helpers, project, plugin }) => {
  return {
    actions,
    helpers,
    project,
    options: plugin.options
  };
};
export {
  createPluginSystemContext
};
//# sourceMappingURL=createPluginSystemContext.js.map
